import React from 'react';
export var LoadingIndicator = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 20 : _b, _c = _a.width, width = _c === void 0 ? 2 : _c, backgroundColor = _a.backgroundColor, color = _a.color;
    return (React.createElement("div", { className: "rfu-loading-indicator__spinner", style: {
            margin: '0 auto',
            borderColor: backgroundColor ? backgroundColor : '',
            borderTopColor: color ? color : '',
            width: size ? size : '',
            height: size ? size : '',
            borderWidth: width ? width : '',
        } }));
};
